export default "__VITE_ASSET__0956eee0__"